module.exports = new __parcel__URL__("favoris.4c725afc.svg").toString();